interface ReportShareClickEvent {
    preventDefault: () => void
    stopPropagation: () => void
}

export function captureReportShareClick(event: ReportShareClickEvent, onShare: () => void) {
    event.preventDefault()
    event.stopPropagation()
    onShare()
}
